var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-typing-indicator",style:(_vm.messageColors)},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }